<template>
  <div class="py-3 h-100">
    <p
      class="fw-bold mb-5"
      :class="{ 'text-danger': invalidFields.includes('datetime') }"
    >
      Claim
    </p>
    <div class="w-100 h-100" v-if="claim">
      <div class="mb-3">
        <label class="small mb-1">Amount Used</label>
        <div class="d-flex">
          <div
            class="bg-secondary-subtle text-center fw-bold px-4 py-2 text-dark rounded"
          >
            {{ Helper.formatMoney(claim.amount_used) || "n/a" }}
          </div>
        </div>
      </div>

      <!-- <iframe
        v-if="claim.attachment"
        :src="claim.attachment.url"
        class="w-100 h-100"
        frameborder="0"
      /> -->

      <div class="mb-3 mt-5">
        <label class="d-block small mb-1">Claim File</label>
        <div
          class="image-grid image-grid-placeholder border-0 bg-dark"
          v-if="claim.attachment"
        >
          <button
            class="btn btn-dark h-100 w-100 lh-sm"
            @click="currentPdf = claim.attachment.url"
          >
            <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
            Click to view
          </button>
        </div>
      </div>
    </div>
    <div class="w-100 h-100" v-if="!claim">
      <div v-if="modelsIsValid" class="w-100 py-3 d-flex justify-content-end">
        <button class="btn btn-success mx-1" @click="submitClaim">
          Submit
        </button>
        <button class="btn btn-secondary mx-1" @click="cancelAttachment">
          Cancel
        </button>
      </div>

      <div class="mb-5">
        <label class="small mb-1">
          Amount Used<sup class="text-danger">*</sup>
        </label>
        <div class="input-group" style="width: 250px">
          <span class="input-group-text border-dark">RM</span>
          <input
            type="number"
            class="form-control border-dark"
            v-model="models.amount_used"
          />
        </div>
      </div>

      <label class="small mb-1 d-block">
        Claim File<sup class="text-danger">*</sup>
      </label>

      <div class="image-grid image-grid-placeholder" v-if="!models.filePreview">
        <button class="btn h-100 w-100 fw-bold lh-sm" @click="addImage()">
          <i class="fa-solid fa-plus fa-2x mb-2 d-block" />
          Add Claim File
        </button>
      </div>

      <div class="image-grid image-grid-placeholder border-0 bg-dark" v-else>
        <button
          class="btn btn-dark h-100 w-100 lh-sm"
          @click="currentPdf = models.filePreview"
        >
          <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
          Click to preview
        </button>
      </div>
    </div>

    <pdf-viewer
      :url="currentPdf"
      v-if="currentPdf"
      @close="currentPdf = null"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PdfViewer from "@/components/PdfViewer";
import AddMaterialForm from "@/components/AddMaterialForm";

export default {
  props: ["componentId", "nodStatus", "nodId", "caseId"],
  components: { AddMaterialForm, PdfViewer },
  data() {
    return {
      claim: null,
      claimId: null,
      fileInput: null,
      invalidFields: [],
      models: {
        amount_used: null,
        filePreview: null,
      },
      currentPdf: null,
    };
  },
  computed: {
    modelsIsValid() {
      return Object.keys(this.models).every((key) => this.models[key]);
    },
  },
  methods: {
    cancelAttachment() {
      this.fileInput = null;

      if (this.models.filePreview) {
        URL.revokeObjectURL(this.models.filePreview);
      }

      Object.keys(this.models).forEach((key) => {
        this.models[key] = null;
      });

      this.Helper.removeToast("Claim PDF removed");
    },
    submitClaim() {
      Swal.fire({
        icon: "question",
        title: "<h5 class='fw-bold'>Submit Claim data?</h5>",
        html: "<p class='mb-0'>This action is not reversible.<br />Data cannot be changed after it is submitted.</p>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(true);

          let _nodId = this.nodId;

          if (!_nodId) {
            const [call, error] = await this.Helper.handlePromise(
              this.API.post("nod-cases", {
                case: this.caseId,
              })
            );

            if (error) {
              console.error(error);

              this.triggerAlert("error", error);
            } else {
              _nodId = call.data._id;
            }
          }

          let url = "nod-claims";

          let apiMethod = "post";

          let body = {
            datetime: new Date().toISOString(),
            amount_used: this.models.amount_used,
          };

          body.nod_case = _nodId;

          const [call, error] = await this.Helper.handlePromise(
            this.API[apiMethod](url, body)
          );

          if (error) {
            console.error(error);

            this.triggerAlert("error", error);
          } else {
            this.claimId = call.data._id;

            await this.uploadFileInput();

            const componentStatus = this.nodStatus;

            componentStatus.claim = true;

            await this.API.put(`nod-cases/${this.nodId}`, {
              componentStatus: componentStatus,
            });

            await this.getClaim(true);

            this.fileInput = null;

            if (this.models.filePreview) {
              URL.revokeObjectURL(this.models.filePreview);
            }

            Object.keys(this.models).forEach((key) => {
              this.models[key] = null;
            });

            this.triggerAlert(
              "success",
              "Claim uploaded",
              "componentIsCompleted",
              this.claimId
            );
          }

          this.Helper.toggleLoadingSpinner(false);
        }
      });
    },
    async uploadFileInput() {
      return new Promise(async (resolve, reject) => {
        let fileModels = {
          ref: "nod-claim",
          refId: this.claimId,
          field: "attachment",
          files: "",
        };

        const formData = new FormData();
        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            formData.append("files", this.fileInput, this.fileInput.name);
          }
        });

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("upload", formData)
        );

        if (error) {
          return reject(error);
        } else {
          return resolve("OK");
        }
      });
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    addImage() {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = true;

      input.accept = "application/pdf";

      input.onchange = this.fileChanged;

      input.click();
    },
    fileChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        if (this.models.filePreview) {
          URL.revokeObjectURL(this.models.filePreview);
        }
        this.fileInput = file;
        this.models.filePreview = URL.createObjectURL(file);
      });

      this.Helper.successToast("Claim PDF added");
    },
    async getClaim(isSilent) {
      if (this.claimId) {
        if (!isSilent) {
          this.Helper.toggleLoadingSpinner(true);
        }

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`nod-claims/${this.claimId}`)
        );

        if (error) {
          this.triggerAlert("error", "Error getting claim data");
        } else {
          this.claim = call.data;
        }

        if (!isSilent) {
          this.Helper.toggleLoadingSpinner(false);
        }
      }
    },
  },
  mounted() {
    this.claimId = this.componentId;

    this.getClaim();
  },
};
</script>